module.exports = __webpack_public_path__ + "static/media/just.9dae51e5.jpg";